import { HttpErrorResponse } from '@angular/common/http';

import { InviteMemberPayload, TellentMember } from '@tellent/types';

import { createEntityCollectionStore, ngrxEvent } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

const idSelector = ({ guid }: { guid: string }) => guid;

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TellentMember>()(
  EntityStoreKey.TellentMembers,
  {
    customActions: adapter => ({
      inviteMember: (state, payload: InviteMemberPayload) => adapter.markAsPending(state),
      inviteMemberSuccess: (state, payload: TellentMember[]) => adapter.markAsPending(state),
      inviteMemberFail: ngrxEvent<HttpErrorResponse>(),
    }),
    idSelector,
  },
);

export {
  actions as TellentMembersActions,
  selectors as TellentMembersSelectors,
  reducer as TellentMembersReducer,
  namespace as TellentMembersNamespace,
};
